import { ActionType, createAction, createAsyncAction } from "typesafe-actions";

import EmailFolder from "@mapmycustomers/shared/enum/EmailFolder";
import Email from "@mapmycustomers/shared/types/email/Email";
import EmailAttachment from "@mapmycustomers/shared/types/email/EmailAttachment";
import EmailThread from "@mapmycustomers/shared/types/email/EmailThread";
import EntityEmailSync from "@mapmycustomers/shared/types/email/EntityEmailSync";
import { EntitiesSupportedByEmailFeature } from "@mapmycustomers/shared/types/entity";

export const initEntityEmails = createAction("@component/entityEmails/init")<{
  entity: EntitiesSupportedByEmailFeature;
}>();

export const destroyEntityEmails = createAction("@component/entityEmails/destroy")();

export const fetchEntityEmailSync = createAsyncAction(
  "@component/entityEmails/fetchEntityEmailSync/request",
  "@component/entityEmails/fetchEntityEmailSync/success",
  "@component/entityEmails/fetchEntityEmailSync/failure"
)<void, EntityEmailSync | undefined, void>();

export const dismissEntityEmailsSync = createAsyncAction(
  "@component/entityEmails/dismissEntityEmailsSync/request",
  "@component/entityEmails/dismissEntityEmailsSync/success",
  "@component/entityEmails/dismissEntityEmailsSync/failure"
)<void, void, void>();

export const setParentEmailThreadsFolder = createAction(
  "@component/entityEmails/setParentEmailThreadsFolder"
)<EmailFolder>();

export const searchParentEmailThreads = createAsyncAction(
  "@component/entityEmails/searchParentEmailThreads/request",
  "@component/entityEmails/searchParentEmailThreads/success",
  "@component/entityEmails/searchParentEmailThreads/failure"
)<
  {
    searchText: string;
  } | void,
  {
    data: EmailThread[];
    totalCount: number;
  },
  void
>();

export const loadParentEmailThreads = createAsyncAction(
  "@component/entityEmails/loadParentEmailThreads/request",
  "@component/entityEmails/loadParentEmailThreads/success",
  "@component/entityEmails/loadParentEmailThreads/failure"
)<
  void,
  {
    data: EmailThread[];
    totalCount: number;
  },
  void
>();

export const openParentEmailThread = createAction("@component/entityEmails/openParentEmailThread")<
  EmailThread["id"]
>();

export const closeParentEmailThread = createAction(
  "@component/entityEmails/closeParentEmailThread"
)();

export const loadChildEmails = createAsyncAction(
  "@component/entityEmails/loadChildEmails/request",
  "@component/entityEmails/loadChildEmails/success",
  "@component/entityEmails/loadChildEmails/failure"
)<void, Email[], void>();

export const loadSendEmail = createAsyncAction(
  "@component/entityEmails/loadSendEmail/request",
  "@component/entityEmails/loadSendEmail/success",
  "@component/entityEmails/loadSendEmail/failure"
)<
  {
    messageId: string;
    onFailure: () => void;
    onSuccess: () => void;
  },
  Email,
  void
>();

export const fetchEmailAttachment = createAsyncAction(
  "@component/entityEmails/fetchEmailAttachment/request",
  "@component/entityEmails/fetchEmailAttachment/success",
  "@component/entityEmails/fetchEmailAttachment/failure"
)<
  {
    attachmentId: EmailAttachment["id"];
    messageId: Email["messageId"];
    onFailure: () => void;
    onSuccess: (file: Blob) => void;
  },
  unknown,
  void
>();

export const refreshParentEmailThread = createAction(
  "@component/entityEmails/refreshParentEmailThread"
)<EmailThread>();

export type Actions = ActionType<
  | typeof closeParentEmailThread
  | typeof destroyEntityEmails
  | typeof dismissEntityEmailsSync
  | typeof fetchEmailAttachment
  | typeof fetchEntityEmailSync
  | typeof initEntityEmails
  | typeof loadChildEmails
  | typeof loadParentEmailThreads
  | typeof loadSendEmail
  | typeof openParentEmailThread
  | typeof refreshParentEmailThread
  | typeof searchParentEmailThreads
  | typeof setParentEmailThreadsFolder
>;
